import CustomValidator from '@mixins/validators/CustomValidator'
import { getYear } from 'date-fns'

export default {
  mixins: [CustomValidator],

  created() {
    this.addCustomValidator('validate_ageOrYear_16', {
      validate: this.validateAgeOrYear.bind(null, 16, 99),
    })
    this.addCustomValidator('validate_ageOrYear_18', {
      validate: this.validateAgeOrYear.bind(null, 18, 99),
    })
  },

  methods: {
    validateAgeOrYear(minAge, maxAge, age) {
      const ageFromYear = getYear(new Date()) - age
      return (age >= minAge && age <= maxAge) || (ageFromYear >= minAge && ageFromYear <= maxAge)
    },
  },
}
